import { Pressable, StyleSheet, View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';

import { getName } from '@pletly/shared';
import { Button, Input, colors, spacing } from '@pletly/ui';
import ImageIcon from '%assets/icons/image.svg';
import { UserAvatar } from '%components';
import { useLoggedUser } from '%context/LoggedUser';

interface Props extends ViewProps {
	onPress?: () => unknown;
}

export const NewPostBar = ({ onPress, style }: Props) => {
	const { t } = useTranslation();
	const user = useLoggedUser();

	return (
		<Pressable style={[styles.root, style]} onPress={onPress}>
			<UserAvatar size={48} username={getName(user)} src={user.photoUrl} />
			<View style={styles.inputColumn}>
				<Input placeholder={`${t('post.new.add-text')}...`} onFocus={onPress} />
				<Button
					accessoryLeft={<ImageIcon />}
					style={styles.addMediaButton}
					variant="filled"
					color="basic"
					onPress={onPress}
				>
					{t('post.add-media')}
				</Button>
			</View>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		backgroundColor: colors.white,
		borderRadius: 16,
		padding: spacing(3),
		gap: spacing(2),
	},
	inputColumn: {
		gap: spacing(2),
		flex: 1,
	},
	addMediaButton: {
		alignSelf: 'flex-start',
	},
});
